<fc-product-action *ngIf="!hasGroups() && groupSettings.moreAction" [pageDetails]="pageDetails" [compareButtonText]="groupSettings.moreAction?.label"></fc-product-action>
<fc-group-dropdown  *ngIf="hasGroups()" [options]="groupSettings.group" [pageDetails]="pageDetails"></fc-group-dropdown>

